var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"container",class:_vm.column},_vm._l((_vm.list),function(v,i){return _c('div',{key:i},[_c('div',{staticClass:"item",class:{ 'active':(_vm.type=='radio' && _vm.index == i) || (_vm.type=='checkbox' && v.checked) },attrs:{"data-i":i},on:{"click":_vm.change}},[_vm._v(_vm._s(v.text))])])}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }